export const environment = {
  apiUrl: 'https://dev-server.justtostudy.kz',
  wsUrl: 'wss://dev-server.justtostudy.kz',
  studentAppUrl: 'https://dev-tutor.justtostudy.kz',
};
